import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

export async function submitWaitlist(data) {
  try {
    await addDoc(collection(db, "waitlist"), {
      name: data.name.trim(),
      mobile: data.mobile.trim(),
      email: data.email.trim(),
      area: data.area.trim(),
      vehicleType: data.vehicleType,
      createdAt: serverTimestamp(),
    });
    return { ok: true };
  } catch (err) {
    console.error("[PARKORA] Waitlist signup failed:", err);
    return { ok: false, error: err.message };
  }
}

export async function submitOwnerRegistration(data) {
  try {
    await addDoc(collection(db, "ownerRegistrations"), {
      name: data.name.trim(),
      mobile: data.mobile.trim(),
      location: data.location.trim(),
      spaceType: data.spaceType,
      numberOfSpaces: Number(data.numberOfSpaces),
      createdAt: serverTimestamp(),
    });
    return { ok: true };
  } catch (err) {
    console.error("[PARKORA] Owner registration failed:", err);
    return { ok: false, error: err.message };
  }
}
